import CartToggler from "./CartToggler";
import SideCart from "./SideCart";
import CartModal from "./CartModal";

class Cart {
    constructor() {
        this.url = "/wp-admin/admin-ajax.php";

        this.cart_toggle = document.querySelector(".js-cart-toggle");
        this.side_cart = document.querySelector(".js-side-cart");
        this.global_modal = document.querySelector(".js-cart-modal");

        this.addToCartForm = this.addToCartForm.bind(this);
        this.addToCartButton = this.addToCartButton.bind(this);

        this.toggle = new CartToggler(this.cart_toggle, this.side_cart);
        this.side = new SideCart(this.side_cart, this);
        this.modal = new CartModal(this.global_modal);

        this._reloadCart();
    }

    addToCartButton(event) {
        if (event.target.classList.contains("ajax_add_to_cart")) {
            event.preventDefault();

            let product_id = event.target.getAttribute("data-product_id");
            if (product_id !== null && product_id !== "") {
                event.target.classList.add("loading");
                this._addCartItem(product_id).then(() => {
                    event.target.classList.remove("loading");
                });
            }
        }
    }

    addToCartForm(event) {
        event.preventDefault();
        let qty = event.target.quantity.value;
        let product_id = event.target.getAttribute("data-product-id");
        if (qty !== undefined && product_id !== "") {
            qty = parseInt(qty);
            this._addCartItem(product_id, qty).then(() => {
            });
        }
    }

    removeFromCart(product_id, cart_key) {
        const reload_data = new FormData();
        reload_data.append("action", "netivo_remove_from_cart");
        reload_data.append("cart_key", cart_key);
        reload_data.append("product_id", product_id);

        const reload_params = new URLSearchParams(reload_data);
        this._getAjaxData(reload_params)
            .then((response) => {
                if (response.status === "success") {
                    this.side.updateSideCart(response.data.cart);
                    this.toggle.maybe_update_toggle(
                        response.data.quantity,
                        response.data.total,
                    );
                } else {
                    // this._display_modal(response.message, response.status, null, null);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    _addCartItem(product_id, quantity = 1) {
        return new Promise((resolve, reject) => {
            const body_data = new FormData();
            body_data.append("action", "netivo_add_to_cart");
            body_data.append("product_id", product_id);
            body_data.append("quantity", quantity);

            const body_params = new URLSearchParams(body_data);

            this._getAjaxData(body_params)
                .then((response) => {
                    if (response.status === "success") {
                        this.modal.displayModal(
                            response.message,
                            response.status,
                            response.data,
                            quantity,
                        );
                        this.toggle.maybe_update_toggle(
                            response.data.total.quantity,
                            response.data.total.price,
                        );
                        this.side.updateSideCart(response.data.cart);
                        resolve();
                    } else {
                        console.log(response);
                        resolve();
                        //this._display_modal(response.message, response.status, null, null);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    resolve();
                });
        });
    }

    _reloadCart() {
        const reload_data = new FormData();
        reload_data.append("action", "netivo_get_cart_data");

        const reload_params = new URLSearchParams(reload_data);

        this._getAjaxData(reload_params)
            .then((response) => {
                this.side.updateSideCart(response.cart);
                this.toggle.maybe_update_toggle(response.quantity, response.total);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    _getAjaxData(data) {
        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Cache-Control": "no-cache",
                },
                body: data,
            })
                .then((response) => {
                    response.json().then((response) => {
                        resolve(response);
                    });
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

export default Cart;
